import { getImage, getTxt } from '@/api/file';

const state = {
    image: {
        carousel: [],
        travel: [],
        events: [],
        hotel: [],
        news: [],
    },
    contents: {
        carousel: [],
        notification: [],
        travel: [],
        events: [],
        hotel: [],
        news: []
    },
    versions: {
        carousel: null,
        notification: null,
        travel: null,
        events: null,
        hotel: null,
        news: null
    },
    titles: {
        notification: []
    },
    loading: {
        carousel: false,
        notification: false,
        travel: false,
        events: false,
        hotel: false,
        news: false,
    },
    error: {
        carousel: null,
        notification: null,
        travel: null,
        events: null,
        hotel: null,
        news: null,
    }
}

const mutations = {
    SET_image(state, { type, images, version, contents }) {
        state.image[type] = images;
        state.contents[type] = contents;
        state.versions[type] = version;
    },
    SET_txt(state, { type, contents, titles }) {
        state.titles[type] = titles;
        state.contents[type] = contents;
    },
    SET_LOADING(state, { type, status }) {
        state.loading[type] = status;
    },
    SET_ERROR(state, { type, error }) {
        state.error[type] = error;
    }
}

const actions = {
    clearCache({ state }, type) {
        if (state.image[type]) {
            state.image[type] = [];
        }
        if (state.contents[type]) {
            state.contents[type] = [];
        }
        if (state.versions[type]) {
            state.versions[type] = null;
        }
        if (state.titles[type]) {
            state.titles[type] = [];
        }
    },
    async fetchImage({ commit}, type) {
        try {
            commit('SET_LOADING', { type, status: true });
            commit('SET_ERROR', { type, error: null });
            
            const data = await getImage(type);
            if (data.success) {
                commit('SET_image', {
                    type,
                    images: data.data.images,
                    version: data.data.version,
                    contents: data.data.contents
                });
                return data;
            }
            return null;
        } catch (error) {
            commit('SET_ERROR', { type, error: error.message || '获取图片失败' });
        } finally {
            commit('SET_LOADING', { type, status: false });
        }
    },
    async fetchTxt({ commit}, type) {
        try {
            commit('SET_LOADING', { type, status: true });
            commit('SET_ERROR', { type, error: null });
            
            const data = await getTxt(type);
            if (data.success) {
                commit('SET_txt', {
                    type,
                    contents: data.data.contents,
                    titles: data.data.titles,
                    version: data.data.version
                });
                return data;
            }
        } catch (error) {
            commit('SET_ERROR', { type, error: error.message || '获取文本失败' });
        } finally {
            commit('SET_LOADING', { type, status: false });
        }
    },
    async fetchAllImages({ dispatch }, types = ['carousel', 'travel', 'events', 'hotel',  'news']) {
        const promises = types.map(type => dispatch('fetchImage', type));
        return Promise.all(promises);
    },
    async fetchAllTexts({ dispatch }, types = ['notification']) {
        const promises = types.map(type => dispatch('fetchTxt', type));
        return Promise.all(promises);
    },
    async fetchAllResources({ dispatch }) {
        const imagePromise = dispatch('fetchAllImages');
        const textPromise = dispatch('fetchAllTexts');
        return Promise.all([imagePromise, textPromise]);
    }
}

const getters = {
    getImage: (state) => (type) => state.image[type] || [],
    getContents: (state) => (type) => state.contents[type] || [],
    getTitles: (state) => (type) => state.titles[type] || [],
    getVersion: (state) => (type) => state.versions[type],
    isLoading: (state) => (type) => state.loading[type] || false,
    getError: (state) => (type) => state.error[type] || null
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 